import { tab } from "@testing-library/user-event/dist/tab";
import { Breadcrumb, Button, Card, Flex, Space } from "antd";
import MainLayout from "components/layouts/MainLayout";
import { useTranslation } from "react-i18next";
import { ReactComponent as ImportIcon } from "../../../assets/icon/importIcon.svg";

const WhiteList = ({
    headPart = "",
    firstRow = () => { },
    table = () => { },
    ModalUpload = () => { },
    setOpenModal = () => { },
}) => {
    const { t } = useTranslation();

    return (
        <MainLayout>
            {ModalUpload()}
            <Space direction="vertical" style={{ width: "100%" }} size={24}>
                <Flex justify="space-between" align="center">
                    <Flex vertical>
                        <Breadcrumb items={[
                            { title: t("home.header"), link: "/" },
                            { title: t('configuration.entity') },
                            { title: t("whitelist.header"), link: "/configuration/whitelist" },
                        ]}
                        />
                        <h2>{t("whitelist.header")}</h2>
                    </Flex>

                    <Button type="default"
                        onClick={() => { setOpenModal(true) }}
                        style={{ width: "max-content", height: "44px", color: "#42526D", padding: "8px 16px", borderRadius: "8px" }}>
                        <Flex align="center" justify="center" gap={8}>
                            <ImportIcon />
                            <span>{t('common.import')}</span>
                        </Flex>

                    </Button>
                </Flex>
                {/* <Card style={{ height: "80vh" }}> */}

                <Space direction="vertical" style={{ width: "100%" }} size={24}>
                    {firstRow()}
                    {table()}
                </Space>
                {/* </Card> */}
            </Space>
        </MainLayout>
    )
}

export default WhiteList;
